import React, { useCallback, useEffect, useState } from 'react';
import {
  Popover,
  Position,
  Card,
  Token,
  Icon,
  Grid,
  Input,
  Text,
  Stack,
  Box,
} from '@chaser/components';
import TwilioService from '../../../services/twilio-service';
import style from './NumericKeypad.module.scss';
import { debounce } from 'lodash';

function DigitButton({ digit, handleDigitInput }) {
  return (
    <button className={style.button} onClick={() => handleDigitInput(digit)}>
      {digit}
    </button>
  );
}

const VALID_DIGITS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

const NumericKeypad = () => {
  const [extension, setExtension] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [digitBuffer, setDigitBuffer] = useState('');

  const sendDigits = useCallback(async digits => {
    setExtension(prev => prev + digits);
    await TwilioService.sendDigits(digits);
    setDigitBuffer('');
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSendDigits = useCallback(debounce(sendDigits, 1000), [sendDigits]);

  const handleDigitInput = useCallback(
    digit => {
      setDigitBuffer(prevBuffer => {
        const newBuffer = prevBuffer + digit;
        debouncedSendDigits(newBuffer);
        return newBuffer;
      });
    },
    [debouncedSendDigits],
  );

  useEffect(() => {
    function handleKeyDown(event) {
      if (VALID_DIGITS.includes(event.key)) {
        handleDigitInput(event.key);
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleDigitInput]);

  return (
    <Popover
      onToggle={setDropdownOpen}
      shown={dropdownOpen}
      position={Position.TOP}
      offset
      target={
        <Token
          borderColor="Mid Neutral 1"
          backgroundColor="transparent"
          style={{
            padding: '14px 16px',
          }}
        >
          <Icon color="White" name="numpad" size={20} />
        </Token>
      }
    >
      <Card backgroundColor="Dark Neutral 1" marginBottom="10px">
        <Box p="small">
          <Stack>
            <Text color="White">Extension</Text>
            <Input value={digitBuffer || extension} disabled width="auto" />
            <Grid alignItems="center" gridColumnGap="3px" gridTemplateColumns="repeat(3, 1fr)">
              {VALID_DIGITS.map(digit => (
                <DigitButton key={digit} digit={digit} handleDigitInput={handleDigitInput} />
              ))}
            </Grid>
          </Stack>
        </Box>
      </Card>
    </Popover>
  );
};

export default NumericKeypad;
